import { render, staticRenderFns } from "./RowSupportMenu.vue?vue&type=template&id=5c63cbb2"
import script from "./RowSupportMenu.vue?vue&type=script&lang=js"
export * from "./RowSupportMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports